export default __webpack_public_path__ + "static/media/Kiss of the White Hand.ce5f378b.jpg";